function getTippyTable(content, maxWidth = 160, placement = 'bottom') {
    return {
        content,
        theme: 'table',
        placement,
        maxWidth,
    }
}

function getTippySidebar(content) {
    return {
        content,
        placement: 'right',
        theme: 'menu',
    }
}

function getTippyAlert(content) {
    return {
        content,
        placement: 'right',
        theme: 'alert',
    }
}

function getTippyNumber(content) {
    return {
        content,
        theme: 'table',
        placement: 'bottom',
        followCursor: true,
    }
}

function getTippyBottom(content, maxWidth) {
    return {
        content,
        theme: 'table',
        placement: 'bottom',
        maxWidth,
    }
}

function getTippyLeft(content, maxWidth) {
    return {
        content,
        theme: 'table',
        placement: 'left',
        maxWidth,
    }
}

function getTippyCardStatus(content) {
    return {
        content,
        theme: 'card-status',
        placement: 'right',
        offset: [0, 8],
        onShow(instance) {
            const scrollParent = instance.reference.closest('.custom-scroll-y')

            if (!scrollParent) {
                return
            }

            const hide = () => instance.hide()

            scrollParent.addEventListener('scroll', hide, { passive: true })
            instance._removeScrollHide = () => scrollParent.removeEventListener('scroll', hide)
        },
        onHidden(instance) {
            instance._removeScrollHide?.()
            instance._removeScrollHide = null
        },
    }
}

function getTippyCalFlow(content, placement = 'right') {
    return {
        content,
        placement,
        theme: 'call-flow-menu',
    }
}

export {
    getTippyTable,
    getTippySidebar,
    getTippyNumber,
    getTippyAlert,
    getTippyLeft,
    getTippyCalFlow,
    getTippyBottom,
    getTippyCardStatus,
}
